import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  HomeIcon, 
  UsersIcon, 
  BuildingStorefrontIcon,
  BriefcaseIcon,
  ShoppingCartIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  CurrencyDollarIcon,
  Cog6ToothIcon,
  ClipboardDocumentListIcon,
  MegaphoneIcon,
  ServerIcon
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Users & Admins', href: '/users', icon: UsersIcon },
  { name: 'Businesses', href: '/businesses', icon: BuildingStorefrontIcon },
  { name: 'Staff & Employees', href: '/staff', icon: BriefcaseIcon },
  { name: 'Products', href: '/products', icon: ShoppingCartIcon },
  { name: 'Invoices', href: '/invoices', icon: DocumentTextIcon },
  { name: 'Mails', href: '/mails', icon: EnvelopeIcon },
  { name: 'Custom SMTP', href: '/smtp-configs', icon: ServerIcon },
  { name: 'Plans', href: '/plans', icon: CurrencyDollarIcon },
  { name: 'Broadcast', href: '/broadcast', icon: MegaphoneIcon },
  { name: 'Audit Logs', href: '/audit-logs', icon: ClipboardDocumentListIcon },
  { name: 'Settings', href: '/settings', icon: Cog6ToothIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const AdminSidebar = () => {
  return (
    <div className="flex h-full flex-grow flex-col overflow-y-auto bg-white border-r border-gray-100 pt-5 pb-4 shadow-sm">
      <div className="flex flex-shrink-0 items-center px-6">
        <div className="flex items-center gap-2 bg-red-50 p-2 rounded-lg w-full">
          <div className="bg-red-600 rounded p-1">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h1 className="text-sm font-bold text-gray-900 tracking-tight leading-none">
              NetrootX BILLING
            </h1>
            <span className="text-xs text-gray-500 font-medium tracking-widest uppercase">Admin</span>
          </div>
        </div>
      </div>
      <div className="mt-8 flex flex-1 flex-col">
        <div className="px-6 mb-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Main Menu</p>
        </div>
        <nav className="flex-1 space-y-1 px-4 pb-4">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  isActive ? 'bg-red-50 text-red-600 relative' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-200'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon
                    className={classNames(
                      isActive ? 'text-red-600' : 'text-gray-400 group-hover:text-gray-600',
                      'mr-3 h-5 w-5 flex-shrink-0 transition-colors duration-200'
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                  {isActive && (
                    <span className="absolute right-3 w-1.5 h-1.5 rounded-full bg-red-600"></span>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default AdminSidebar;
